var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMcfIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.973,
    height: 20,
    viewBox: "0 0 19.973 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MCF-Icon",
    transform: "translate(9.986 10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MCF-Icon-2",
    "data-name": "MCF-Icon",
    transform: "translate(-9.986 -10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M82.388,9.606h0c0-.009-.009-.018-.013-.027a1.215,1.215,0,0,0-.275-.42l-.974-.973h0L73.287.347a1.16,1.16,0,0,0-1.655,0l-.963.962a1.165,1.165,0,0,0,0,1.66l7.014,7.014-7.024,7.025a1.176,1.176,0,0,0-.018,1.668l.973.973a1.207,1.207,0,0,0,1.694.007l8.814-8.815.007,0A1.176,1.176,0,0,0,82.388,9.606Z",
    transform: "translate(-62.487 0)",
    fill: "#101820"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M12.949,49.81a1.163,1.163,0,0,1-.249.367L6.907,55.971a1.189,1.189,0,0,1-1.679,0L4.255,55a1.176,1.176,0,0,1,.018-1.667l4.609-4.609a17.939,17.939,0,0,0,1.783.6A17.381,17.381,0,0,0,12.949,49.81Zm-8.491-4.5L.348,49.416a1.185,1.185,0,0,0,0,1.676l.973.973a1.185,1.185,0,0,0,1.676,0l4.16-4.16A5.484,5.484,0,0,1,4.459,45.305Z",
    transform: "translate(0 -40.271)",
    fill: "#636569"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M48.618,33.566a17.381,17.381,0,0,1-2.284-.484,17.94,17.94,0,0,1-1.783-.6l1.186-1.186a1.164,1.164,0,0,1,1.657-.008l.974.974A1.184,1.184,0,0,1,48.618,33.566Zm-4.159-5.215-.973-.973a1.184,1.184,0,0,0-1.676,0l-1.683,1.683a5.484,5.484,0,0,0,2.7,2.6l1.634-1.635A1.184,1.184,0,0,0,44.459,28.351Z",
    transform: "translate(-35.668 -24.027)",
    fill: "#a1a3a6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcfIcon);
export default __webpack_public_path__ + "static/media/MCF-Icon.bb5d86b4654f8d76a84dc6fee091baca.svg";
export { ForwardRef as ReactComponent };